import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Shinhan from "../components/NoticeServicePage/Shinhan";
import ZzeungNotice from "../components/NoticeServicePage/ZzeungNotice";

const NoticeServicePage: React.FC = () => {
   return (
      <Routes>
         <Route path={"/notice/service/shinhan"} element={<Shinhan />} />
         <Route path={"/notice/service/zzeung"} element={<ZzeungNotice />} />
      </Routes>
   );
};

export default NoticeServicePage;
